<template>
  <transition name="fade">
    <v-progress-circular
      v-if="loading"
      indeterminate
      size="16"
      color="#CED2D6"
      class="d-block"
      style="margin: auto 40px"
      tran
    />
    <div v-else>{{ commaFormat(amount) }}원</div>
  </transition>
</template>

<script>
import { commaFormat } from '@/util'
export default {
  props: ['loading', 'amount'],
  methods: {
    commaFormat,
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  &.v-progress-circular {
    position: absolute;
  }
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
